import { render } from "./DialogQRFail.vue?vue&type=template&id=092a8c38"
import script from "./DialogQRFail.vue?vue&type=script&lang=js"
export * from "./DialogQRFail.vue?vue&type=script&lang=js"
script.render = render

export default script